import { useEffect, useState } from 'react';
import { Skeleton } from '@radix-ui/themes';
import RequestUtil from '../../utils/APIRequestUtil';
import PopularBlog from './PopularBlog';

export default function HomePopularBlogsHeader() {
    const [blogs, setBlogs] = useState([]);
    const [dataReady, setDataReady] = useState(false);

    useEffect(() => {
        RequestUtil.get('/api/popular-blogs')
            .then(async (resp) => {
                if (resp?.ok) {
                    const body = await resp.json();
                    if (Array.isArray(body)) setBlogs(body);
                }
                setDataReady(true);
            })
            .catch(() => setDataReady(true));
    }, []);

    if (!dataReady) {
        return (
            <div className="redesign-popular-row">
                {Array.from({ length: 10 }).map((_, i) => (
                    <Skeleton key={i} width="56px" height="72px" />
                ))}
            </div>
        );
    }

    if (blogs.length === 0) return null;

    return (
        <div className="redesign-popular-row">
            {blogs.slice(0, 10).map((blog, index) => (
                <PopularBlog
                    key={index}
                    name={blog.name}
                    domainName={blog.domainName}
                    blogAdminLargeImageURL={blog.blogAdminLargeImageURL}
                />
            ))}
        </div>
    );
}
